export const LOGIN = 'auth/LOGIN';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';
export const RESET_LOGIN_STATUS = 'auth/RESET_LOGIN_STATUS';

export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'auth/LOGOUT_ERROR';

export const CHECK_LOCAL_AUTH = 'auth/CHECK_LOCAL_AUTH';

export const RESET_PASSWORD = 'account/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'account/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'account/RESET_PASSWORD_ERROR';

export const FORGOT_PASSWORD = 'forgot-password/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS =
  'forgot-password/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'forgot-password/FORGOT_PASSWORD_ERROR';

export const VERIFY_CODE = 'forgot-password/VERIFY_CODE';
export const VERIFY_CODE_SUCCESS = 'forgot-password/VERIFY_CODE_SUCCESS';
export const VERIFY_CODE_ERROR = 'forgot-password/VERIFY_CODE_ERROR';

export const CHANGE_PASSWORD = 'forgot-password/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS =
  'forgot-password/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'forgot-password/CHANGE_PASSWORD_ERROR';
